import { Add } from 'icon'

import BaseBtn from './BaseBtn'

const AddBtn = (props) => {
  const { disabled, onClick, loading, tag } = props

  return (
    <BaseBtn
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      tag={tag}
      icon={<Add color="grey" size={1} />}
      color={'grey'}
      bg_color={'white'}
    />
  )
}

export default AddBtn
